if (!customElements.get('card-slider')) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      if (this.classList.contains('js-testimonials')) {
        window.addEventListener('resize', () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider.params.effect === 'slide';

          if (isMobile && !isSlideEffect || !isMobile && isSlideEffect) {
            this.reInitSlider(swiperOptions);
          }
        });
      }
    }

    reInitSlider(swiperOptions) {
      this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {

      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerViewMobile || 'auto',
        spaceBetween: swiperOptions.spaceBetweenMobile || 0,
        resistanceRatio: 0.72,
        navigation: {
          nextEl: swiperOptions.swiperButtonNext || '.swiper-button--next',
          prevEl: swiperOptions.swiperButtonPrevious || '.swiper-button--prev',
        },
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0,
          }
        }
      };

      const isArticlesSlider = this.classList.contains('js-articles');

      if (isArticlesSlider) {
        sliderOptions.breakpoints[575] = {
          slidesPerView: 2,
        };
      } else if (this.classList.contains('js-testimonials')) {
        if (window.innerWidth < mobileWidth) {
          sliderOptions.spaceBetween = 4;
          sliderOptions.breakpoints[480] = {
            slidesPerView: 2
          };
          sliderOptions.breakpoints[750].slidesPerView = 1;
        } else {
          sliderOptions = {
            effect: 'fade',
            slidesPerView: 1,
            rewind: true,
            followFinger: false,
            navigation: {
              nextEl: '.swiper-button--next',
              prevEl: '.swiper-button--prev',
            },
          };
        }

      }

      this.slider = new Swiper(this, sliderOptions);

      // update slider index
      setTimeout(() => {
        if (this.classList.contains('js-variant-images')) {
          this.updateSliderIndexFromVariant();
        }
      }, 200);
    }

    updateSliderIndexFromVariant() {
      const cardProductHoverMedia = this.closest('.hover-img');
      const visibleMedia = cardProductHoverMedia.previousElementSibling;
      if (!visibleMedia) return;

      const visibleMediaId = visibleMedia.getAttribute('data-id');
      const slide = this.querySelector(`.swiper-slide[data-id="${visibleMediaId}"]`);
      if (!slide) return;

      const ariaLabel = slide.getAttribute('aria-label');
      const parts = ariaLabel.split(' / ');
      const index = parts[0];
      
      this.slider.slideTo(index, 0);
    }
  }

  customElements.define('card-slider', CardSlider);
}